<Loader :loading="loading" />

<div>
  <div v-if="is_uploading" class="text-center text-xxs my-3">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Uploading...</span>
    </div>
    <p>Uploading document...</p>
  </div>
  <div class="w-100 px-3 p-2 border-bottom">
    <button class="btn btn-sm btn-primary text-xxs" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
      <i class="bi bi-plus-lg"></i> New Folder
    </button>
    <button class="btn btn-sm btn-secondary text-xxs ms-2" v-if="folderStack.length > 0"  @click="triggerFileUpload">
      <i class="bi bi-upload"></i> Upload Document
    </button>
    <input
      type="file"
      ref="warehouse_file"
      class="d-none"
      @change="handleFileUpload"
      accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.png,.jpg,.jpeg,.gif,.bmp"
    />
  </div>

  <div class="px-1">
    <nav class="mb-0 mt-3 p-0 px-2 text-xs">
      <ol class="breadcrumb">
        <li class="breadcrumb-item text-dark fw-bold" :class="{ active: folderStack.length === 0 }">
          <span v-if="folderStack.length === 0">DocumentWarehouse</span>
          <a v-else href="#" @click.prevent="goBack" class="text-decoration-none text-dark">DocumentWarehouse</a>
        </li>
    
        <li
          v-for="(folder, index) in folderStack"
          :key="folder.id"
          class="breadcrumb-item fw-bold"
          :class="{ active: index === folderStack.length - 1 }"
        >
          <a
            v-if="index !== folderStack.length - 1"
            href="#"
            @click.prevent="goBack()"
            class="text-decoration-none text-dark"
          >
            {{ folder.folder_name }}
          </a>
          <span v-else>{{ folder.folder_name }}</span>
        </li>
      </ol>
    </nav>
    <div v-if="selectedDocumentIds.length > 0" class="mb-2">
      <button class="btn btn-primary btn-sm" @click="openMoveToFolderModal">
        Move Selected ({{ selectedDocumentIds.length }}) to Folder
      </button>
    </div>
    <table v-if="currentFolders.length > 0 || currentFiles.length > 0" class="table table-light text-xs">
      <thead>
        <tr class="text-xxs">
          <th class="text-center">
            <input
              type="checkbox"
              @change="toggleSelectAll($event)"
              :checked="selectedDocumentIds.length === currentFiles.length && currentFiles.length > 0"
            />
          </th>
          <th class="text-center"><i class="bi bi-file-earmark"></i></th>
          <th class="fw-bold">Name</th>
          <th>Created</th>
          <th>Approved by</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <!-- Render folders -->
        <FolderView
          v-for="folder in currentFolders"
          :key="folder.id"
          :folder="folder"
          @open-folder="handleOpenFolder"
          @folder-deleted="remove_folder(folder.id)"
        />
        <!-- Render files -->
        <tr v-for="fileItem in currentFiles" :key="'file-' + fileItem.id">
          <td class="text-center">
            <input type="checkbox" :value="fileItem.id" v-model="selectedDocumentIds" />
          </td>
          <td class="text-center">
            <img :src="getFileIcon(fileItem.file.s3_url)" class="file-icon download-icon w-20px" />
          </td>
          <td class="text-xs text-dark">
            <div @click="previewDocument(fileItem)">

              <span class="file-name">{{ getFileName(fileItem.file.s3_url) }}</span>
              <a :href="fileItem.file.s3_url" download :title="getFileName(fileItem.file.s3_url)" class="download-btn" @click.stop>
                <img src="https://cdn-icons-png.flaticon.com/128/724/724933.png" class="download-icon w-20px" />
              </a>
            </div>
          </td>
          <td class="text-xs text-dark">
            {{ fileItem.file.date || '—' }}
          </td>
          <td class="text-xs text-dark">
            <ul class="list-unstyled mb-1">
              <li v-for="user in fileItem.approved_by" :key="user.id">
                {{ user.first_name }} {{ user.last_name }}
              </li>
            </ul>
          </td>
          <td>
          <button class="btn btn-danger btn-sm text-xxs" @click.stop="delete_folder_document(fileItem.id)">Delete</button>
          <button class="btn btn-primary btn-sm text-xxs ms-2 d-none" @click.stop="manage_document_permissions(fileItem.id)">Manage Document Permissions</button>
          </td>
        </tr>
      </tbody>
    </table>

        <!-- Move-to-Folder Modal -->



    <!-- Show "Folder empty" message only if both folders and files are empty -->
    <div v-if="currentFolders.length === 0 && currentFiles.length === 0" class="text-center mt-5">
      <img src="@/assets/images/empty-folder.png" class="w-150" alt="">
      <p>This folder is empty</p>
    </div>

    <div v-else>
      <p>No folders found</p>
    </div>
  </div>
</div>

 <div id="move_to_folder_modal" class="modal fade" tabindex="-1" aria-labelledby="moveToFolderModalLabel" aria-hidden="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg">
      <div class="modal-header">
        <h5 class="modal-title text-xs fw-500">Move {{ selectedDocumentIds.length }} Document(s) to Folder</h5>
<button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>

      </div>
      <div class="modal-body modal-body-scroll">
        <select v-model="selectedFolderId" class="form-select">
          <option disabled value="">-- Select Folder --</option>
          <option v-for="folder in currentFolders" :value="folder.id" :key="folder.id">
            {{ folder.folder_name }}
          </option>
        </select>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary btn-sm" @click="moveSelectedDocumentsToFolder" :disabled="selectedFolderId">
          Move
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <label for="">Folder name</label>
        <input type="text" v-model="folder_name" placeholder="Enter folder name">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="create_folder" data-bs-dismiss="modal">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- Manage Permissions Modal -->
<div class="modal fade" id="manage_document_permissions_modal" tabindex="-1" aria-labelledby="manageDocumentPermissionsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-xs fw-500">Manage Permissions - {{ selected_file.name }}</h5>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body modal-body-scroll">
        <!-- Add User -->
        <input type="text" v-model="searchQuery" @input="searchUsers" placeholder="Search users by name or email" class="form-control mb-2" />

        <!-- Current Permissions -->
        <div v-for="user in folder_document_permissions" :key="user.id" class="d-flex align-items-center mb-2">
          <div class="me-2"><strong>{{ user.portal_access.first_name }} </strong>
            <br><small>{{ user.portal_access.email }}</small>
            <span v-if="user.is_owner"> (Owner)</span>
          </div>

          <div class="form-check ms-auto me-2">
            <input class="form-check-input" type="checkbox" v-model="user.view" :disabled="user.is_owner"> View
          </div>
          <div class="form-check me-2">
            <input class="form-check-input" type="checkbox" v-model="user.upload" :disabled="user.is_owner"> Upload
          </div>
          <div class="form-check me-2">
            <input class="form-check-input" type="checkbox" v-model="user.download" :disabled="user.is_owner"> Download
          </div>
          <div class="form-check me-2">
            <input class="form-check-input" type="checkbox" v-model="user.delete " :disabled="user.is_owner"> Delete
          </div>

          <button v-if="!user.is_owner" @click="removeUser(user.id)" class="btn btn-sm btn-outline-danger">Remove</button>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary text-xs rounded-5" @click="save_folder_document_permissions">Save Changes</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="document_preview_modal" tabindex="-1" aria-labelledby="documentPreviewModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="documentPreviewModalLabel">Document Preview</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- Dynamically display document content -->
        <div v-if="previewDocumentType === 'pdf'">
          <embed :src="previewDocumentUrl" type="application/pdf" width="100%" height="600px">
        </div>
        <div v-else-if="previewDocumentType === 'word'">
          <!-- Word document viewer -->
          <iframe :src="previewDocumentUrl" width="100%" height="600px"></iframe>
        </div>
        <div v-else-if="previewDocumentType === 'excel'">
          <!-- Excel document viewer -->
          <iframe :src="previewDocumentUrl" width="100%" height="600px"></iframe>
        </div>

        <div v-else-if="previewDocumentType === 'image'">
          <img :src="previewDocumentUrl" class="img-fluid" alt="Document Image">
        </div>

        <div v-else>
          <p class="text-center">No preview available for this document type.</p>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>